import { render } from "./PermissionsForAuthGroup.vue?vue&type=template&id=3cefdef0"
import script from "./PermissionsForAuthGroup.vue?vue&type=script&lang=js"
export * from "./PermissionsForAuthGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__